import { backgroundRequest } from './sessionActivity';

// AKM POC §9.1 — tarayıcıda üretilen dosyanın (DataTable yerleşik CSV indirmesi) dışa aktarma olayı: dosya indirmesini
// BEKLETMEZ, hata kullanıcıya gösterilmez (olay yazılamazsa indirme yine olur). Arka plan isteği: oturumun hareketsizlik
// penceresini uzatmaz (kullanıcı etkinliği istemcide zaten sayılır).
// api.js YALNIZ olay yazılırken yüklenir: DataTable gibi her yerde kullanılan paylaşılan bileşen bu modülü içe aktarır ve
// onu içe aktaran her modül (ve testi) api.js + i18n zincirini yüklemek zorunda kalmaz.
export const logClientExport = ({ reportKey, title, rowCount }) => import('./api')
  .then(({ default: api }) => api.post(
    '/v1/audit-logs/client-export',
    { reportKey, title, rowCount },
    backgroundRequest({ skipErrorToast: true }),
  ))
  .catch(() => undefined);
